export default function Footer() {
  return (
    <footer id="footer" className="relative bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50"></i>
              </span>
              <span className="font-heading text-lg text-background-50">91吃瓜爆料网</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              国内领先的吃瓜视频聚合平台。提供91吃瓜视频在线观看与91吃瓜在线播放服务，每日更新最新最全的吃瓜视频在线看合集。娱乐圈八卦、社会热点、网红争议，即点即看。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '关于我们', href: '#about' },
                { label: '热门专题', href: '#carousel' },
                { label: '吃瓜榜单', href: '#ranking' },
                { label: '精彩视频', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">热门标签</h3>
            <div className="flex flex-wrap gap-2">
              {['明星八卦', '社会热点', '网红争议', '综艺名场面', '91吃瓜在线观看', '吃瓜视频在线看', '91吃瓜在线播放'].map((tag) => (
                <span
                  key={tag}
                  className="inline-block px-3 py-1 bg-background-50/10 text-xs text-background-50/70 rounded-lg cursor-pointer hover:bg-primary-500/30 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/50 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 91吃瓜爆料网. All Rights Reserved.
          </p>
          <p className="text-xs text-background-50/40">
            本站内容均来自网络公开资源，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}